import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Spin from 'components/common/Spin';
import useStyles from '../styles';
import Conversations from '../components/Conversations';

const ConvoList = ({
  conversations,
  loading
}) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);

  if (loading) return <Spin spinning />

  return (
    <Grid container spacing={2} className={classes.root}>
      <Helmet title="Inbox" />
      <Grid item md={12}>
        <div className={classes.threadsContainer}>
          <Conversations
            user={user}
            conversations={conversations}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default ConvoList;
